import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <label for="choose-topic-title">
  {{#if this.labelIcon}}
    {{d-icon this.labelIcon}}
  {{/if}}
  <span>{{i18n this.labelText}}</span>
</label>

<TextField
  @value={{this.topicTitle}}
  @placeholderKey="choose_topic.title.placeholder"
  @id="choose-topic-title"
  {{did-insert this.focusInput}}
/>

{{#if this.loading}}
  <p>{{i18n "loading"}}</p>
{{else}}
  {{#if this.noResults}}
    <p>{{i18n "choose_topic.none_found"}}</p>
  {{else}}
    <div class="choose-topic-list" role="radiogroup">
      {{#each this.topics as |t|}}
        <div class="controls existing-topic">
          <label class="radio">
            <Input
              id={{concat "choose-topic-" t.id}}
              @checked={{eq t.id this.selectedTopicId}}
              @type="radio"
              name="choose_topic_id"
              {{on "click" (action "chooseTopic" t)}}
            />
            <TopicStatus @topic={{t}} @disableActions={{true}} />
            <span class="topic-title">
              {{replace-emoji t.title}}
            </span>
            <span class="topic-categories">
              {{bound-category-link
                t.category
                ancestors=t.category.predecessors
                hideParent=true
                link=false
              }}
            </span>
          </label>
        </div>
      {{/each}}
    </div>
  {{/if}}
{{/if}}
*/
{
  "id": "F8ZkcmhV",
  "block": "[[[10,\"label\"],[14,\"for\",\"choose-topic-title\"],[12],[1,\"\\n\"],[41,[30,0,[\"labelIcon\"]],[[[1,\"    \"],[1,[28,[35,1],[[30,0,[\"labelIcon\"]]],null]],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,1],[12],[1,[28,[35,2],[[30,0,[\"labelText\"]]],null]],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,3],[[4,[38,4],[[30,0,[\"focusInput\"]]],null]],[[\"@value\",\"@placeholderKey\",\"@id\"],[[30,0,[\"topicTitle\"]],\"choose_topic.title.placeholder\",\"choose-topic-title\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"loading\"]],[[[1,\"  \"],[10,2],[12],[1,[28,[35,2],[\"loading\"],null]],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"noResults\"]],[[[1,\"    \"],[10,2],[12],[1,[28,[35,2],[\"choose_topic.none_found\"],null]],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,0],[14,0,\"choose-topic-list\"],[14,\"role\",\"radiogroup\"],[12],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,0,[\"topics\"]]],null]],null],null,[[[1,\"        \"],[10,0],[14,0,\"controls existing-topic\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,0,\"radio\"],[12],[1,\"\\n            \"],[8,[39,7],[[16,1,[28,[37,8],[\"choose-topic-\",[30,1,[\"id\"]]],null]],[24,3,\"choose_topic_id\"],[4,[38,10],[\"click\",[28,[37,11],[[30,0],\"chooseTopic\",[30,1]],null]],null]],[[\"@checked\",\"@type\"],[[28,[37,9],[[30,1,[\"id\"]],[30,0,[\"selectedTopicId\"]]],null],\"radio\"]],null],[1,\"\\n            \"],[8,[39,12],null,[[\"@topic\",\"@disableActions\"],[[30,1],true]],null],[1,\"\\n            \"],[10,1],[14,0,\"topic-title\"],[12],[1,\"\\n              \"],[1,[28,[35,13],[[30,1,[\"title\"]]],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,1],[14,0,\"topic-categories\"],[12],[1,\"\\n              \"],[1,[28,[35,14],[[30,1,[\"category\"]]],[[\"ancestors\",\"hideParent\",\"link\"],[[30,1,[\"category\",\"predecessors\"]],true,false]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[1]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]]]],[]]]],[\"t\"],false,[\"if\",\"d-icon\",\"i18n\",\"text-field\",\"did-insert\",\"each\",\"-track-array\",\"input\",\"concat\",\"eq\",\"on\",\"action\",\"topic-status\",\"replace-emoji\",\"bound-category-link\"]]",
  "moduleName": "discourse/components/choose-topic.hbs",
  "isStrictMode": false
});